import Button, { BUTTON_VARIANT } from "@/common/elements/Button";
import { ActionsContainer } from "./styles";

const FormActionsFooter = ({ onReset = () => {}, onSaveClick = () => {} }) => {
  return (
    <>
      <ActionsContainer>
        <Button type="secondary" color="secondary" onClick={onReset}>
          Reset
        </Button>
        <Button type="primary" color="primary" onClick={onSaveClick}>
          Save
        </Button>
      </ActionsContainer>
    </>
  );
};

export default FormActionsFooter;
